<template>
    <div v-if="word" class="iat-item pb-3 h-100 d-flex flex-column justify-content-between">
        <iat-category-header :categories="categories" />
        <div class="d-flex align-items-center justify-content-center">
            <div class="iat-item__cat-word-container mt-5 text-center">
                <div
                    class="iat-item__cat-word mb-4"
                    :class="wordColor"
                >
                    {{ $t(word.wordTranslationKey) }}
                </div>
                <div
                    class="iat-item__cat-word mb-4"
                    :class="wordColor"
                >
                    <img
                        v-if="$t(word.wordTranslationKey + '_IMG') !== word.wordTranslationKey + '_IMG'"
                        :src="ASSETS_URL + $t(word.wordTranslationKey + '_IMG')"
                        width="200"
                        height="200"
                    />
                </div>
                <div class="d-flex flex-column align-items-center" v-if="answerError">
                    <div class="iat-item__wrong-answer mb-2 text-center">
                    X
                    </div>
                    <div class="iat-item__wrong-answer-text text-center">
                        {{ $t(`${TEXT_TYPES.INTERACTION_BASE}_IAT_WRONG_KEY`) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="iat-item__control d-flex justify-content-between px-2">
            <div class="iat-item__choice-button">
                <iat-choice-button
                    :value="IAT_CHOICE.L"
                    @click="handleChoiceButtonClick"
                >
                    L
                </iat-choice-button>
            </div>
            <div class="iat-item__choice-button">
                <iat-choice-button
                    :value="IAT_CHOICE.R"
                    @click="handleChoiceButtonClick"
                >
                    R
                </iat-choice-button>
            </div>
        </div>
    </div>
</template>
<script>
import iatCategoryHeader from '@/components/ui/iatCategoryHeader'
import iatChoiceButton from '@/components/inputs/iatChoiceButton'
import { ASSETS_URL } from '@/constants/misc'
import { TEXT_TYPES } from '@/constants/i18n'

const IAT_CHOICE = {
    L: 'L',
    R: 'R'
}

export default {
    name: 'iatItem',
    components: {
        'iat-category-header': iatCategoryHeader,
        'iat-choice-button': iatChoiceButton
    },
    props: {
        categories: {
            type: Object
        },
        word: {
            type: Object
        },
        timingError: {
            type: Boolean
        } 
    },
    watch: {
        word() {
            this.startTime = this.getTime()
        }
    },
    data() {
        return {
            ASSETS_URL,
            IAT_CHOICE,
            TEXT_TYPES,
            startTime: null,
            endTime: null,
            answerError: false,
        }
    },
    computed: {
        categoryIds() {
            const { topLeft, topRight, bottomLeft, bottomRight } = this.categories

            const top = [topLeft && topLeft.id, topRight && topRight.id].filter(Boolean)
            const bottom = [bottomLeft && bottomLeft.id, bottomRight && bottomRight.id].filter(Boolean)
            const left = [topLeft && topLeft.id, bottomLeft && bottomLeft.id].filter(Boolean)
            const right = [topRight && topRight.id, bottomRight && bottomRight.id].filter(Boolean)

            return {
                top,
                bottom,
                left,
                right,
            }
        },
        wordColor() {
            if(this.categoryIds.top.indexOf(this.word.categoryId) !== -1) {
                return 'iat-item__target'
            }
            return 'iat-item__aux'
        },
    },
    methods: {
        getTime() {
            return Math.round(window.performance.now())
        },
        handleChoiceButtonClick(value) {
            if(!this.timingError) {
                const chosenCategory = value === IAT_CHOICE.L ? this.categoryIds.left : this.categoryIds.right            
                const answerCorrect = chosenCategory.indexOf(this.word.categoryId) !== -1

                const answer = {
                    answerCorrect,
                    ...this.word,
                    timeElapsed: this.getTime() - this.startTime,
                }

                if(answerCorrect) {
                    this.$emit('answer', answer)
                    this.answerError = false
                } else {
                    this.answerError = true
                }
            }
        },
        handleKeyDown(e) {
            if(!e.repeat) {
                if(e.key === 'e') {
                    this.handleChoiceButtonClick(IAT_CHOICE.L)
                } else if (e.key === 'i') {
                    this.handleChoiceButtonClick(IAT_CHOICE.R)
                }
            }
        }
    },
    mounted() {
        this.keyListener = window.addEventListener('keydown', this.handleKeyDown)
        this.startTime = this.getTime()
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeyDown)
    }

}
</script>
<style lang="scss">

.iat-item__cat-word-container {
    height: 220px;
}

.iat-item__cat-word {
    font-weight: bold;
    font-size: 3em;
    @media screen and (max-width: 500px) {
        font-size: 2.75em;
    }
    @media screen and (max-width: 450px) {
        font-size: 2.5em;
    }
    @media screen and (max-width: 400px) {
        font-size: 2.2em;
    }

    @media screen and (max-width: 341px) {
        font-size: 2em;
    }
}

.iat-item__wrong-answer {
    font-size: 2.5em;
    font-weight: bold;
    line-height: 1.25em;
    height: 58px;
    width: 58px;
    border-radius: 50%;
    border: 3px solid $bq-iat-color-aux;
    color: $bq-iat-color-aux;
}

.iat-item__target {
    color: $bq-iat-color-target;
}

.iat-item__aux {
    color: $bq-iat-color-aux;
}

.iat-item__choice-button {
    display: none !important;
    height: 150px;
    width: 150px;
    @media (pointer: coarse) {
        display: block !important;
    }
    @media (max-width: 370px) {
        height: 128px;
        width: 128px;
    }
}
</style>